import httpClient from '../../../shared/lib/httpClient';
import { ENDPOINTS } from '../../../shared/services/api/endpoints';

/**
 * Fetch users with filtering, sorting, and pagination
 * @param {Object} body - Request body matching GetUsersRequest
 * @param {Array} [body.filters] - Array of filter criteria {field, operator, value}
 * @param {Array} [body.sorts] - Array of sort criteria {field, direction}
 * @param {number} [body.pageNumber=1] - Page number
 * @param {number} [body.pageSize=8] - Items per page
 * @returns {Promise<Object>} Response with users array and pagination metadata
 */
export async function getUsers(body = {}) {
    const response = await httpClient.post(ENDPOINTS.USER.LIST, body);
    return response.data;
}

/**
 * Fetch filter options for user listing (roles, products, statuses)
 * @returns {Promise<Object>} Response with roles, products, and statuses arrays
 */
export async function getUserFilters() {
    const response = await httpClient.get(ENDPOINTS.IDENTITY.FIRM_GROUPS);
    return response.data;
}

/**
 * Fetch firm subscriptions with their associated products
 * @returns {Promise<Object>} Response with subscriptions array containing products
 */
export async function getFirmSubscriptions() {
    const response = await httpClient.get(ENDPOINTS.USER.SUBSCRIPTIONS);
    return response.data;
}
